import { render } from "./TvmServiceCoupons.vue?vue&type=template&id=40dfd198&scoped=true"
import script from "./TvmServiceCoupons.js?vue&type=script&lang=js&external"
export * from "./TvmServiceCoupons.js?vue&type=script&lang=js&external"

import "./TvmServiceCoupons.vue?vue&type=style&index=0&id=40dfd198&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40dfd198"],['__file',"src/Components/ChatWidget/TvmServiceCoupons/TvmServiceCoupons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40dfd198"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40dfd198', __exports__)) {
    api.reload('40dfd198', __exports__)
  }
  
  module.hot.accept("./TvmServiceCoupons.vue?vue&type=template&id=40dfd198&scoped=true", () => {
    api.rerender('40dfd198', render)
  })

}


export default __exports__